import { Component, OnInit } from '@angular/core';
import { UserService } from "../../services/user.service";
import { User } from "../../models/user";
import { environment } from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MovimientosComponent } from 'src/app/modales/movimientos/movimientos.component';

@Component({
  selector: 'app-tarjeta',
  templateUrl: './tarjeta.component.html',
  styleUrls: [
    './tarjeta.component.css',
    '../login/font-awesome/css/font-awesome.min.css',
    '../login/perfect-scrollbar/dist/css/perfect-scrollbar.min.css',
    '../login/css/table.css',
    '../login/css/estilos.css'
  ],
  providers: [UserService]
})
export class TarjetaComponent implements OnInit {
  public identity;
  public token;
  public tarjetas = [];
  public mvtotarjetas;
  public user: User;
  actual = environment.actual;
  public colorFondo = environment.entidad[this.actual].colorMenu;
  public letraColor = environment.entidad[this.actual].letraColor;
  paginaactual: number = 1;
  public tarjetaConfig
  private param
  private cred;
  private afin;
  private Config;
  public mobile

  constructor(
    private _userService: UserService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog
  ) {
    this.user = new User(1, '', '', '', '', '', '', 0, 0);
  }

  ngOnInit() {
    this.spinner.show()
    this.identity = JSON.parse(this._userService.GetsessionStorage('identity'));
    this.param = JSON.parse(this._userService.GetsessionStorage('parametrosGenerales'));
    this.Config = JSON.parse(this._userService.GetsessionStorage('config'));
    this.token = this._userService.GetsessionStorage('token');
    for (let i = 0; i < this.param.length; i++) {
      if (this.param[i].url == 'tarjeta_afin') {
        console.log('afin')
        this.afin = true
        this.cred = false
        this.tarjetaConfig = this.Config.tarjetaafin
      } else if (this.param[i].url == 'tarjeta_cred') {
        console.log('cred')
        this.cred = true
        this.afin = false;
        this.tarjetaConfig = this.Config.tarjetacred
      }
    }
    this.consultaTarjetas();

    if (window.screen.width > 768) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  consultaTarjetas() {
    if (this.afin) {
      this._userService.httpGet('tarjetaAfinidad/'+this.identity.CODASOCIADO).subscribe(response => {
        if (response.status == 'success') {
          this.tarjetas = response.details;
          console.log(this.tarjetas.length)
        } else {
          console.log(response.details)
        }
        this.spinner.hide()
      },
        error => {
          console.log(<any>error);
          this.spinner.hide()
        }
      );
    } else if (this.cred) {
      this._userService.httpGet('tarjetaCredito/'+this.identity.CODASOCIADO).subscribe(response => {
        if (response.status == 'success') {
          this.tarjetas = response.details;
          console.log(this.tarjetas.length)
        } else {
          console.log(response.details)
        }
        this.spinner.hide()
      },
        error => {
          console.log(<any>error);
          this.spinner.hide()
        }
      );
    }

  }

  consultarMtvoTarjeta(codtarjeta) {
    this.spinner.show()
    this._userService.httpGet('mvtotarjetas/'+codtarjeta).subscribe(response => {
      if (response.status == 'success') {
        this.mvtotarjetas = response.details;
        if(!this.mobile){
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = false;
          dialogConfig.width = '100%';
          const modalRef = this.dialog.open(MovimientosComponent, {
            autoFocus: false,
            maxHeight: '80vh',
            width: '100%', //you can adjust the value as per your view
            data: { datos: this.mvtotarjetas, modulo: 'mvtotarjetas', op: 1 }
          });

          modalRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
          });
        }
        console.log(this.mvtotarjetas)
      } else {
        alert(response.message);
      }
      this.spinner.hide()
    },
      error => {
        console.log(<any>error);
        this.spinner.hide()
      }
    );
  }

}
